import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.scss']
})
export class ConfirmEmailComponent implements OnInit {
  cid: string;
	confirmResponse: string;
	confirmFail: boolean = false;
	confirmForm: FormGroup;
  loading: boolean = true;

  showEmailForm: boolean = true;

  animationKey: boolean = true;

  constructor(private route: ActivatedRoute, private http: HttpClient, @Inject(FormBuilder) fb: FormBuilder) {
    route.params.subscribe(params => {
      this.cid = params['cid']
    });

    this.confirmForm = fb.group({
      email: new FormControl('', [Validators.required, Validators.email])
    });
  }

  private restartAnimation() {
    this.animationKey = false;
    setTimeout(() => this.animationKey = true, 10); // brief delay to let DOM clear
  }

  ngOnInit() {
    this.http.post('https://reframedb.org/api/auth/confirm',
      {"token": this.cid},
      {
        observe: 'response',
        headers: new HttpHeaders().set('content-type', 'application/json')
      }
    ).subscribe(res => {
      this.confirmResponse = res.body['message'];
      if (res.body['status'] == 'fail') this.confirmFail = true;
  		else this.confirmFail = false;
      this.loading = false;
    },
    (err: HttpErrorResponse) => {
      console.log(err);
      this.confirmResponse = err.error.message;
      if (err.status != 501) this.confirmFail = true;
      this.loading = false;
    })
  }

  onSubmit(event){
    this.showEmailForm = false;
    this.http.post('https://reframedb.org/api/auth/confirm/link',
      {'email': this.confirmForm.controls.email.value, app: 'crestdb'},
      {
        observe: 'response',
        headers: new HttpHeaders().set('content-type', 'application/json')
      }
    ).subscribe((re) => {
      let credentials = re.body;
      this.confirmResponse = credentials['message'];
      this.confirmFail = credentials['status'] === 'fail';
      this.restartAnimation();
    },
    (err: HttpErrorResponse) => {
      this.confirmResponse = err.error.message;
      this.restartAnimation();
    })
  }

    getErrorMessage() {
    return this.confirmForm.controls['email'].hasError('required') ? 'You must enter a value' :
      this.confirmForm.controls['email'].hasError('email') ? 'Not a valid email' : '';
  }

}
